import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

import { FaCalendarCheck } from "react-icons/fa";
import { fetchUserDetails, fetchUserStats } from "../../redux/adminReducer";
import Loader from "../../common/loader";
import Booking from "../booking/Booking";
function UserDetails() {
  const { userId } = useParams();
  const { translations, dir } = useSelector((state) => state.language);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const userDetails = useSelector(
    (state) => state.admin.userDetails?.data || []
  );

  const userStats = useSelector((state) => state.admin.userStats?.data || []);

  useEffect(() => {
    setLoading(true);
    const payload = {
      id: userId,
    };
    dispatch(fetchUserStats(payload));
    dispatch(fetchUserDetails(userId)).then(() => {
      setLoading(false);
    });
  }, [dispatch, userId]);

  const BASE_URL = process.env.REACT_APP_BASE_URL || "https://jeema.co/api/v2/";
  const logo =
    userDetails?.profilePicture || userDetails?.profilePicture === ""
      ? `${BASE_URL}${encodeURIComponent("brand/Image.jpg")}`
      : `${BASE_URL}${encodeURIComponent(userDetails?.profilePicture)}`;

  return (
    <Layout>
      <div className="min-h-screen w-full px-4 py-4">
        <section className="pt-1 grid grid-cols-2 items-center">
          <h1 className="text-xl font-bold text-white">
            {translations.user_details.userDetails}
            <small className="text-2xl font-semibold text-gray-600"> |</small>
            <small className="font-normal text-gray-600">
              {" "}
              {translations.user_details.userDetailsManagement}
            </small>
          </h1>
          <div className="text-md text-white flex items-center justify-end space-x-1 ">
            <div className="rounded-full bg-[#5A189A] py-2 px-3">
              <Link to="/" className=" text-white no-underline cursor-pointer">
                {translations.user_details.dashboard}
              </Link>
              <span className="mx-1">/</span>
              <Link to="/users" className="text-white no-underline">
                {translations.user_details.users}
              </Link>
              <span className="mx-1">/</span>
              <span className=" text-green-300">
                {translations.user_details.userDetails}
              </span>
            </div>
          </div>
        </section>
        {loading ? (
          <Loader />
        ) : (
          <div className="grid grid-cols-1 gap-4 mt-4">
            {/* first row */}
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              {/* Left Column: Profile Details (2/4 width) */}
              <div className="md:col-span-2 bg-gray-800 rounded-xl p-6 shadow-md flex items-center gap-10">
                {/* Profile Section */}
                <div className="flex flex-col items-center justify-center">
                  <img
                    src={logo}
                    alt="Profile"
                    className="w-24 h-24 rounded-full object-cover"
                  />
                  <h2 className="text-white text-lg font-semibold mt-2 text-center">
                    {userDetails?.name || "No Name"}
                  </h2>
                </div>

                {/* Info Section */}
                <div className="text-white space-y-3">
                  <p>
                    {translations.user_details.email} :{" "}
                    {userDetails?.email ||
                      translations.user_details.notAvailable}
                  </p>
                  <p>
                    {translations.user_details.gender} :{" "}
                    {userDetails?.gender === 0
                      ? translations.user_details.male
                      : userDetails?.gender === 1
                      ? translations.user_details.female
                      : translations.user_details.other}
                  </p>
                  <p>
                    {translations.user_details.phone} :
                    <span
                      dir="ltr"
                      style={{
                        display: "inline-block",
                        marginLeft: "6px",
                        unicodeBidi: "plaintext",
                      }}
                    >
                      {userDetails?.fullPhoneNumber ||
                        translations.user_details.notAvailable}
                    </span>
                  </p>

                  <p>
                    {translations.user_details.country} :{" "}
                    {userDetails?.country_name ||
                      translations.user_details.notAvailable}
                  </p>
                </div>
              </div>

              {/* Middle Column: Total Bookings (1/4 width) */}
              <div className="bg-gray-800 rounded-xl p-6 shadow-md flex flex-col items-center justify-center text-white">
                <div className="bg-green-500 rounded-full p-4">
                  <FaCalendarCheck className="text-white text-2xl" />
                </div>
                <p className="text-3xl font-bold mt-2">
                  {userStats?.totalBookings || 0}
                </p>
                <p className="text-sm">
                  {translations.user_details.totalBookings}
                </p>
              </div>

              {/* Right Column: Total Profit (1/4 width) */}
              <div className="bg-gray-800 rounded-xl p-6 shadow-md flex flex-col items-center justify-center text-white">
                <div className="bg-yellow-500 rounded-full p-4">💰</div>
                <p className="text-3xl font-bold mt-2">
                  SAR {userStats?.totalProfit || 0}
                </p>
                <p className="text-sm">
                  {translations.user_details.totalProfit}
                </p>
              </div>
            </div>

            {/* Booking row */}
            <div className="bg-gray-800 rounded-xl p-6 shadow-md">
              <Booking userId={userId} role="user" salonId={""} />
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default UserDetails;
